import type { BookingAck, BookingRequestPayload } from 'epic/common-form/Booking';
import type { Observable, SchedulerLike } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

import type { QuotingWorkspaceType } from './quote';

export interface BookingRequestEpicApi {
  requestBooking(payload: BookingRequestPayload, withExecution: boolean): Observable<BookingAck>;
  requestBookingV2(payload: BookingRequestPayload, screen: QuotingWorkspaceType): Observable<BookingAck>;
}

function getScreenParam(screen: QuotingWorkspaceType): string {
  switch (screen) {
    case 'ordersBasket':
      return 'screen=ordersBasket';
    default:
      throw new Error('Unhandled screen type');
  }
}

function getBookingUrl(withExecution: boolean): string {
  return `api/v1/dynamic/book-${withExecution ? 'with' : 'without'}-execution`;
}

export function bookingRequestApi(
  http: IHttpClient,
  ackTimeoutInMillis: number,
  scheduler?: SchedulerLike,
): BookingRequestEpicApi {
  return {
    requestBooking(payload, type) {
      return http
        .post<BookingAck>({ url: getBookingUrl(type), body: payload, timeOut: ackTimeoutInMillis }, scheduler)
        .pipe(map(r => r.payload));
    },
    requestBookingV2(payload, screen) {
      return http
        .post<BookingAck>(
          { url: `api/v2/book-with-execution?${getScreenParam(screen)}`, body: payload, timeOut: ackTimeoutInMillis },
          scheduler,
        )
        .pipe(map(r => r.payload));
    },
  };
}
